"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowContext = void 0;
var _react = _interopRequireDefault(require("react"));
var OverflowContext = exports.OverflowContext = /*#__PURE__*/_react.default.createContext(null);